
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1729477861790",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2126",
    "width": "16",
    "height": "16"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M288 32v224c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32zM656.4 32v224c0 17.7-14.3 32-32 32H400.4c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32zM1024.4 32v224c0 17.7-14.3 32-32 32H768.4c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32zM288 400v224c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32zM656.4 400v224c0 17.7-14.3 32-32 32H400.4c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32zM1024.4 400v224c0 17.7-14.3 32-32 32H768.4c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32zM288 768v224c0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32V768c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32zM656.4 768v224c0 17.7-14.3 32-32 32H400.4c-17.7 0-32-14.3-32-32V768c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32zM1024.4 768v224c0 17.7-14.3 32-32 32H768.4c-17.7 0-32-14.3-32-32V768c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32z",
        "p-id": "2127"
      }
    }
  ]
})
    }
  